import { ReactNode } from "react";

// Custom wrapper component
export default function ContentWrapper({ children, customHeight }: { children: ReactNode, customHeight?: String }) {
    return (
      <div className={`bg-white rounded-lg shadow-xs w-full ${customHeight || 'h-mainscreenheight3'} overflow-auto`}>
        {children}
      </div>
    );
  };